/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_3Inputs */

const en_svr_guidance_onsite_3 = /** @type {(inputs: Svr_Guidance_Onsite_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If revisit: additional tools/cabling? New part (make & model)?`)
};

const ja_svr_guidance_onsite_3 = /** @type {(inputs: Svr_Guidance_Onsite_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再訪問の場合：追加工具やケーブルは？新しい部品（メーカーと型番）は？`)
};

const fr_svr_guidance_onsite_3 = /** @type {(inputs: Svr_Guidance_Onsite_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si nouvelle visite : outils/câblage supplémentaires ? Nouvelle pièce (marque et modèle) ?`)
};

const de_svr_guidance_onsite_3 = /** @type {(inputs: Svr_Guidance_Onsite_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei erneutem Besuch: zusätzliche Werkzeuge/Verkabelung? Neues Teil (Hersteller und Modell)?`)
};

/**
* | output |
* | --- |
* | "If revisit: additional tools/cabling? New part (make & model)?" |
*
* @param {Svr_Guidance_Onsite_3Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_3 = /** @type {((inputs?: Svr_Guidance_Onsite_3Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_3Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_3(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_3(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_3(inputs)
	return de_svr_guidance_onsite_3(inputs)
});